export default __webpack_public_path__ + "static/media/atome_banner_Hk.be6d7bc7.webp";